import styled from 'styled-components';

import GithubLogoSVG from '../../../../assets/github-logo.svg';
import ProductHuntLogoSVG from '../../../../assets/icons/product-hunt.svg';
import BehanceLogoSVG from '../../../../assets/icons/behance.svg';

export const GithubLogo = styled(GithubLogoSVG)`
  height: 24px;
  width: 24px;
  margin-right: 15px;
  cursor: pointer;
`;
export const ProductHuntLogo = styled(ProductHuntLogoSVG)`
  height: 24px;
  width: 24px;
  margin-right: 15px;
  cursor: pointer;
`;
export const BehanceLogo = styled(BehanceLogoSVG)`
  height: 24px;
  width: 24px;
  cursor: pointer;
`;

export const FooterContainer = styled.div`
  width: 100vw;
  padding: 40px 10vw;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #F4F5F7;
  position: relative;
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const FooterSections = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 20px 0;
    border-bottom: 1px solid #EBECF0;
  }
`;
export const Title = styled.h4`
  font-family: Circular-Bold;
  color: #253858;
  letter-spacing: 1px;
  font-size: 14px;
`;
export const Link = styled.a`
  margin-bottom: 10px;
  font-family: Circular-Book;
  color: #42526E;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  ${props => props.bold && 'font-family: Circular-Bold'};
  ${props => props.blue && 'color: #0052CC'};
  ${props => props.orange && 'color: #FF8B00'};
`;

export const FooterSectionItem = styled.span`
  margin-bottom: 10px;
  font-family: Circular-Book;
  color: #42526E;
  font-size: 14px;
`;

export const ContactArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const ContactInput = styled.input`
  color: #42526E;
  font-size: 13px;
  height: 32px;
  padding-left: 10px;
  border-radius: 3px;
  background: white;
  border: 1px solid #C1C7D0;
  width: 100%;
  margin-right: 10px;
`;
export const ContactButton = styled.button`
  border: 1px solid #0052CC;
  border-radius: 3px;
  font-family: Circular-Bold;
  font-size: 13px;
  background: transparent;
  padding: 0 20px;
  cursor: pointer;
  transition: all 250ms;
  &:hover {
    color: white;
    background: #0052CC;
  }
`;
export const Email = styled.a`
  font-family: Circular-Bold;
  text-decoration: none;
  color: #253858;
  &:hover {
    text-decoration: underline;
  }
`;
export const Copyright = styled.span`
  font-family: Circular-Book;
  font-size: 11px;
  color: #333333;
  margin-top: 10px;
  text-align: center;
  @media (min-width: 768px) {
    padding-top: 20px;
    border-top: 1px solid #EBECF0;
  }
`;
